// @flow

import { handleMapRequest } from '../phasedActionHelpers';

import type { LoadWorkAction } from '../../actions/work';

export type State = {
  +[key: string]: {|
    +loading: boolean,
    +loaded: boolean,
    +entities: string,
  |},
  loading: boolean,
};

const initialState = {
  loading: false,
};

export default function works(state: State = initialState, action: LoadWorkAction): State {
  if (action.type === 'FETCH_WORK' && action.cacheId) {
    return handleMapRequest(state, action, action.cacheId);
  }

  return state;
}
